export type AgentCategory = "tax" | "finance" | "logistics" | "other";

export interface Agent {
  id: string;
  name: string;
  description: string;
  category: AgentCategory;
  icon: string;
  iconColor: string;
  iconBgColor: string;
  userCount: number;
  isDefault: boolean;
  features: string[];
}

export interface AgentPreference {
  context: string;
  responseStyle: "concise" | "detailed" | "professional";
  autoSave: boolean;
  notifications: boolean;
  allowDataOptimization: boolean;
  localStorage: {
    enabled: boolean;
    maxHistory: number;
  };
}

export interface SessionAgentMapping {
  sessionId: string;
  agentId: string;
  createdAt: Date;
}

export const categoryLabels: Record<AgentCategory, string> = {
  tax: "税务",
  finance: "财务",
  logistics: "物流",
  other: "其他",
};

export const defaultAgentPreference: AgentPreference = {
  context: "",
  responseStyle: "professional",
  autoSave: true,
  notifications: true,
  allowDataOptimization: true,
  localStorage: {
    enabled: true,
    maxHistory: 100,
  },
};
